import { Modal } from 'components/Modal/Modal';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { useModal } from 'hooks/useModal';
import React, { FC } from 'react';

interface ClearAllModalProps {
  onClick: () => void;
  disabled?: boolean;
}

const ClearAllModal: FC<ClearAllModalProps> = ({
  onClick,
  disabled = false,
}) => {
  const { open, isOpen, close } = useModal();
  return (
    <div>
      <GraniteButton
        size="small"
        variant="ghost"
        className="hover:!border-accent-primary hover:!text-accent-primary"
        onClick={open}
        disabled={disabled}
      >
        Clear all services
      </GraniteButton>
      <Modal isVisible={isOpen} close={close} className="w-full max-w-[624px]">
        <div className="p-8">
          <div>
            <h1 className="text-2xl font-bold text-white">
              Clear all services?
            </h1>
            <p className="mt-2 text-base font-bold text-neutral-500">
              This will only remove the services from your cart. Locations won’t
              be affected and can still be used to add new services.
            </p>
          </div>
          <div className="mt-8 flex gap-5">
            <GraniteButton variant="secondary" size="large" onClick={close}>
              Cancel
            </GraniteButton>
            <GraniteButton
              size="large"
              variant="destructive"
              onClick={() => {
                onClick();
                close();
              }}
            >
              Clear services
            </GraniteButton>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ClearAllModal;
